export const FEATURES_LOADED = "features::loaded";
export const FEATURE_UPDATE = "features::feature::update";
export const PACKAGE_UPDATE = "features::package::update";